import { useMutation } from "react-query";
import { employeesService } from "@services/employee-service";

export const useSendEmployeeReferralMutation = () => {
  return useMutation(employeesService.sendMedicalExamReferral);
};
